import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

/**
 * Resolves /dashboard straight to the user's team dashboard instead of
 * showing an intermediate "Welcome to SyncSimple" + team-picker screen
 * (that page, UserDashboard.tsx, is left in place but unrouted in case its
 * pending-invitations / unclaimed-teams UI is needed again later).
 *
 * Almost everyone has exactly one team. If someone ever has more than one,
 * we pick the most recently joined (userTeams is already ordered by
 * joined_at desc in AuthContext) rather than making them choose — switching
 * teams from there happens via the TeamSwitcher already in the dashboard header.
 */
export const DashboardHome: React.FC = () => {
  const { loading, userTeams } = useAuth()

  if (loading || !userTeams || userTeams.length === 0) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
          <p className="mt-2 text-muted-foreground">Loading your dashboard…</p>
        </div>
      </div>
    )
  }

  return <Navigate to={`/dashboard/team/${userTeams[0].team_id}`} replace />
}
